import request from 'axios'

//获取申请入驻时已经填写过的信息
export function getJoinDetail(query) {
    return request({
        url: '/admin/tenant_apply/detail',
        method: 'get',
        params: query
    })
}
//保存申请入驻信息
export function saveTenantApply(query) {
    return request({
        url: '/admin/tenant_apply/save',
        method: 'post',
        data: query
    })
}
//提交入驻申请
export function postTenantApply(query) {
    return request({
        url: '/admin/tenant_apply/apply',
        method: 'post',
        data: query
    })
}
//获取页面停留时间
export function sessionKeepAlive (query) {
    return request({
        url: '/admin/tenant_apply/sessionKeepAlive',
        method: 'get',
        params: query
    })
}
//重新提交的请求
export function toDraft (query) {
    return request({
        url: '/admin/tenant_apply/toDraft',
        method: 'get',
        params: query
    })
}